import { CalendarDayInterface } from '../../utils';

export enum CapitalActionEntryType {
  Expense = 'expense',
  Investment = 'investment',
  GeneralCapitalCall = 'general-capital-call',
  AdvanceSubscriptionPayment = 'advance-subscription-payment',
  CapitalContributionCall = 'capitalContributionCall',
  Fees = 'fees',
  CapitalRefund = 'capital-refund',
  CapitalDistribution = 'capital-distribution',
  Equalisation = 'equalisation',
}

export enum DrawdownSourcePriority {
  UnallocatedCommitmentFirst = 'unallocated-commitment-first',
  RecallableDistributionFirst = 'recallable-distribution-first',
  Manual = 'manual',
}

export enum CapitalActionTypes {
  CapitalActionCreated = 'capitalActionCreated',
}

export enum CapitalActionTransactionSubType {
  ExpensesCall = 'expensesCall',
  InvestmentCall = 'investmentCall',
  GeneralCapitalCall = 'generalCapitalCall',
  AdvanceSubscriptionCall = 'advanceSubscriptionCall',
  AdvanceSubscriptionUsed = 'advanceSubscriptionUsed',
  CapitalContributionCall = 'capitalContributionCall',
  FeesCall = 'feesCall',
  CapitalRefund = 'capitalRefund',
  RecallableReturnOfCapital = 'recallableReturnOfCapital',
  NonRecallableReturnOfCapital = 'nonRecallableReturnOfCapital',
  RecallableIncome = 'recallableIncome',
  NonRecallableIncome = 'nonRecallableIncome',
  RecallableDistributionOutsideOfCarry = 'recallableDistributionOutsideOfCarry',
  NonRecallableDistributionOutsideOfCarry = 'nonRecallableDistributionOutsideOfCarry',
  CarriedInterest = 'carriedInterest',
  CallReceivable = 'callReceivable',
  DistributionsPayable = 'distributionsPayable',
  CarriedInterestPayable = 'carriedInterestPayable',
  EqualisationCall = 'equalisationCall',
  EqualisationRefund = 'equalisationRefund',
  EqualisationInterestPaidIn = 'equalisationInterestPaidIn',
  EqualisationInterestPaidOut = 'equalisationInterestPaidOut',
}

export type LinkedCapitalAction = {
  id: string;
  name: string;
  ledgerDate: CalendarDayInterface;
  actionDueDate?: CalendarDayInterface;
  totalAmountLcy: number;
  capitalActionHeader: {
    investments: number;
    expenses: number;
    capitalRefunds: number;
    fees: number;
    additionalPayments: number;
  };
  originalInvestorBreakdown: Array<{
    investorName: string;
    commitmentId: string;
    investments: number;
    fees: number;
    expenses: number;
    workingCapital: number;
    returnOfCapital: number;
    netCallOrDistribution: number;
  }>;
  newInvestorBreakdown: Array<{
    investorName: string;
    commitmentId: string;
    investments: number;
    fees: number;
    expenses: number;
    workingCapital: number;
    returnOfCapital: number;
    netCallOrDistribution: number;
    callOverpaidOrUnderpaid: number;
    isNewTransferee?: boolean;
  }>;
};
